// extracted by mini-css-extract-plugin
var _1 = "App-module__ico--GlGmC";
var _2 = "App-module__icoHidden--zMt4d";
export { _1 as "ico", _2 as "icoHidden" }
